import { Injectable } from '@angular/core';
import { Observable, of, throwError } from 'rxjs';

import { ICreateAddressReqeust, ILookup, Logger } from '../../../../core';
import {
  IAccount,
  AccountsListApiResponse,
  ICreateAccountRequest,
  ICreateAccountResponse,
  IUpdateAccountRequest,
  IAssignScopesRequest,
  IRevokeScopesRequest,
  IValidateAccountRequest,
  IAccountsPaginationParameters
} from '../dtos';
import { IAccountsApiClient } from './i-accounts-api.client';
import { accountsData } from '../data';
import { IValidateUserRequest } from '../../users';

@Injectable({
  providedIn: 'root'
})
export class AccountsApiInMemoryClient implements IAccountsApiClient {
  private accounts: IAccount[] = [];
  private currentId = 1;

  get(paginationParameters: IAccountsPaginationParameters | undefined): Observable<AccountsListApiResponse> {
    const page = paginationParameters?.page || 1;
    const pageSize = paginationParameters?.pageSize || 10;
    const paginatedAccounts = this.accounts.slice((page - 1) * pageSize, page * pageSize);

    return of(accountsData.accountsResponse);
  }

  // Create a new account
  create(request: ICreateAccountRequest): Observable<ICreateAccountResponse> {
    const newAccount: IAccount = {
      id: (this.currentId++).toString(),
      englishName: request.name,
      createdOnUtc: new Date().toISOString(),
      modifiedOnUtc: new Date().toISOString(),
      adminAccount: {
        id: (this.currentId++).toString(),
        firstName : 'first name',
        lastName: 'last name',
        email: 'name@name.com'}
    };

    this.accounts.push(newAccount);

    return of(accountsData.createAccountResponse);
  }

  addHeadQuarterAddress(id: string, body: ICreateAddressReqeust): Observable<void> {
    return of();
  }

  // Get an account by ID
  getById(id: string): Observable<IAccount> {
    const account = this.accounts.find((a) => a.id === id);
    return account ? of(accountsData.accountResponse) : throwError(() => new Error(`Account with ID ${id} not found.`));
  }

  // Update an account
  update(id: string, request: IUpdateAccountRequest): Observable<void> {
    const account = this.accounts.find((a) => a.id === id);

    if (!account) {
      return throwError(() => new Error(`Account with ID ${id} not found.`));
    }

    account.englishName = request.name;
    account.modifiedOnUtc = new Date().toISOString();

    return of(void 0);
  }

  getScopes(id: string): Observable<ILookup<string>[]> {
    return of(accountsData.accountScopes);
  }

  assignScopes(id: string, request: IAssignScopesRequest): Observable<void> {
    const account = this.accounts.find((a) => a.id === id);

    if (!account) {
      return throwError(() => new Error(`Account with ID ${id} not found.`));
    }

    Logger.debug('Account scopes has been assigned', request);

    return of(void 0);
  }

  revokeScopes(id: string, request: IRevokeScopesRequest): Observable<void> {
    const account = this.accounts.find((a) => a.id === id);

    if (!account) {
      return throwError(() => new Error(`Account with ID ${id} not found.`));
    }

    Logger.debug('Account scopes has been revoked', request);

    return of(void 0);
  }

  accountValidation(request: IValidateAccountRequest): Observable<void> {
    return of();
  }

  adminAccountValidation(request: IValidateUserRequest): Observable<void> {
    return of();
  }
}
